import { Nilable } from "@nahuelmorata/ngx-extras";

export interface IAgeRangeDTO {
    age_range: string;
    male_percentage: number;
    male_number: number;
    female_percentage: number;
    female_number: number;
}

export class AgeRangeDTO {
    public ageRange = "";
    public malePercentage = 0;
    public maleNumber = 0;
    public femalePercentage = 0;
    public femaleNumber = 0;

    constructor(json: Nilable<Partial<IAgeRangeDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }


    }
    cargarDTO(json: Partial<IAgeRangeDTO>) {
        if (json?.age_range != null) {
            this.ageRange = json.age_range;
        }
        if (json?.male_percentage != null) {
            this.malePercentage = json.male_percentage;
        }
        if (json?.male_number != null) {
            this.maleNumber = json.male_number;
        }
        if (json?.female_percentage != null) {
            this.femalePercentage = json.female_percentage;
        }
        if (json?.female_number != null) {
            this.femaleNumber = json.female_number;
        }
    }
}